(function() {
'use strict';

angular
    .module('core')
    .config(configure);

function configure($provide, $httpProvider) {
    $provide.factory('timerInterceptor', timerInterceptor);

    function timerInterceptor() {
        const COMMON_THRESHOLD = 20;

        return {
            request(config) {
                try {
                    config.headers['x-timer'] = new Date().getTime();
                } catch (e) {}
                return config;
            },

            response(data) {
                try {
                    const timeElapsed = (new Date().getTime() - data.config.headers['x-timer']) / 1000;
                    const threshold = data.config.headers['x-threshold'] || COMMON_THRESHOLD;

                    if (timeElapsed > threshold) {
                        const utm = JSON.parse($('body').attr('user')).UtmId;
                        const msg = `OVERTHRESHOLD | ${
                                timeElapsed}s | ${
                                data.config.url} | ${
                                utm} | ${
                                window.navigator.userAgent}`;
                        const r = new XMLHttpRequest();

                        r.open('POST', 'website/logging/log', true);
                        r.setRequestHeader('content-type', 'application/json');
                        r.send(JSON.stringify({ LogLevel: 'Warn', Message: msg }));
                    }
                } catch (e) {}
                return data;
            }
        };
    }

    if ($httpProvider.interceptors.indexOf('timerInterceptor') < 0) {
        $httpProvider.interceptors.push('timerInterceptor');
    }
}
})();
